(function($) {
    'use strict';
    $(document).ready(function() {
        $(".header-language-select").on("change", function(ev) {
            document.location = $(this).val();
        });

    });
}(jQuery));